/**
 * Sélection de cellules et de colonnes d'un tableau du site.
 *
 * Le geste a lieu dans le canvas (Maj+clic, comme dans le Proposal), les
 * actions vivent dans le panneau latéral : les deux sont deux arbres React
 * différents. Ce registre module-level les relie, comme le catalogue de tables
 * relie la sidebar au document — hors du store Puck, lu par
 * `useSyncExternalStore`.
 *
 * La sélection est portée par des **indices** (rectangle de lignes et de
 * colonnes) : les clés de lignes peuvent être dupliquées, un rapprochement par
 * clé ferait fuiter la sélection sur des lignes homonymes. La conversion en
 * clés n'a lieu qu'au moment de fusionner (`rectToKeys`).
 */

const EMPTY = { blockId: null, rect: null, columnKeys: [] };

let selection = EMPTY;
const listeners = new Set();

function emit() {
  listeners.forEach((listener) => listener());
}

export function subscribeTableSelection(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getTableSelection() {
  return selection;
}

/** Rectangle de cellules d'un bloc. `null` efface la sélection. */
export function setTableCellSelection(blockId, rect) {
  selection = rect ? { blockId, rect, columnKeys: [] } : EMPTY;
  emit();
}

/** Colonnes sélectionnées par leur en-tête. */
export function setTableColumnSelection(blockId, columnKeys) {
  selection = columnKeys?.length ? { blockId, rect: null, columnKeys } : EMPTY;
  emit();
}

export function clearTableSelection() {
  if (selection === EMPTY) return;
  selection = EMPTY;
  emit();
}
